import { render, staticRenderFns } from "./CourseCoverageMonitoring.vue?vue&type=template&id=70ed8a9a&scoped=true"
import script from "./CourseCoverageMonitoring.vue?vue&type=script&lang=js"
export * from "./CourseCoverageMonitoring.vue?vue&type=script&lang=js"
import style0 from "./CourseCoverageMonitoring.vue?vue&type=style&index=0&id=70ed8a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ed8a9a",
  null
  
)

export default component.exports